import {Form, Formik} from 'formik';
import {useNavigate} from 'react-router-dom';
import {toast} from 'react-toastify';
import * as Yup from 'yup';
import {useCallback, useState} from 'react';
import {Icons} from '../assets/icons/Icons';
import {useAuth} from '../service';
import Stepper from '../stepper/Stepper';
import EmailStep from './EmailStep';
import IdentityStep from './IdentityStep';
import PhoneStep from './PhoneStep';

const RegistrationContainer = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);

  const {mutateAsync: register} = useAuth().register;
  const {mutateAsync: sendverificationCode} = useAuth().sendverificationCode;

  const steps = [{name: 'Email'}, {name: 'Phone'}, {name: 'Identity'}];

  // Define validation schemas for each step
  const validationSchemas = [
    // Email step validation
    Yup.object({
      email: Yup.string().email('Invalid email address').required('Email is required'),
      receiveOffers: Yup.boolean(),
    }),
    // Phone step validation
    Yup.object({
      phone: Yup.string()
        .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits')
        .required('Phone number is required'),
    }),
    // Identity step validation
    Yup.object({
      firstName: Yup.string().required('First name is required'),
      lastName: Yup.string().required('Last name is required'),
      middleName: Yup.string(),
      dob: Yup.string().required('Date of birth is required'),
      termsAgreed: Yup.boolean()
        .oneOf([true], 'You must accept the terms and conditions')
        .required('You must accept the terms and conditions'),
      password: Yup.string().min(6).required('Password is required'),
    }),
  ];

  // Initial form values
  const initialValues = {
    email: '',
    receiveOffers: false,
    phone: '',
    firstName: '',
    middleName: '',
    lastName: '',
    dob: '',
    termsAgreed: false,
    referalCode: '',
    password: '',
  };

  const nextStep = useCallback(() => {
    setCurrentStep(currentStep + 1);
  }, [currentStep]);

  const prevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleSubmit = useCallback(
    async (values, actions) => {
      console.log({values, actions, currentStep});
      if (currentStep === 1) {
        actions.setSubmitting(true);
        await sendverificationCode({email: values.email}).then((res) => {
          console.log({res});
          nextStep();
          actions.setTouched({});
          actions.setSubmitting(false);
        });
      } else if (currentStep < steps.length - 1) {
        nextStep();
        actions.setTouched({});
        actions.setSubmitting(false);
      } else {
        // Final submission
        const {
          email,
          phone,
          firstName: firstname,
          lastName: secondname,
          dob: birth_date,
          password,
        } = values;
        const data = {
          firstname,
          secondname,
          birth_date,
          phone,
          email,
          password,
        };
        await register(data)
          .then(() => {
            toast.success('Success!');
            navigate('/login');
          })
          .finally(() => actions.setSubmitting(false));
      }
    },
    [currentStep, navigate, nextStep, register, sendverificationCode, steps.length],
  );

  // Get the title for the current step
  const getStepTitle = () => {
    switch (currentStep) {
      case 0:
        return 'Enter your email adress';
      case 1:
        return 'Enter your mobile number';
      case 2:
        return 'Enter your identity';
      default:
        return '';
    }
  };

  return (
    <div
      className="container-fluid min-vh-100 d-flex flex-column w-100 gradient-bg"
      style={{
        padding: '23px 14px 21px 14px',
        position: 'relative',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div
        className="ml-[17px] mb-[56px] cursor"
        onClick={() => {
          if (currentStep > 0) {
            setCurrentStep((prev) => prev - 1);
          } else {
            navigate(-1);
          }
        }}
      >
        <Icons.BackWithBG />
      </div>
      <div className="row justify-content-center position-relative">
        <div className="">
          <h1 className="text-white text-center mb-[51px]" style={{fontSize: '20px'}}>
            {getStepTitle()}
          </h1>

          <Stepper steps={steps} currentStep={currentStep} />

          <div
            className="cards rounded-4 pt-[29px] pb-[33px] px-[24px] mt-[28px] primary-gradient-border"
            style={{
              // borderImageSource:
              //   "linear-gradient(136.63deg, #6765FF 0.66%, #000000 100%)",
              // border: "2px solid",
              background: 'rgba(0, 0, 0, 0.5)',
              backdropFilter: 'blur(4px)',
              boxSizing: 'border-box',
            }}

            /* Group 403 */
          >
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchemas[currentStep]}
              onSubmit={handleSubmit}
              validateOnChange={true}
              validateOnBlur={true}
            >
              {(formikProps) => {
                const renderStepContent = () => {
                  switch (currentStep) {
                    case 0:
                      return <EmailStep formik={formikProps} />;
                    case 1:
                      return <PhoneStep formik={formikProps} onBack={prevStep} />;
                    case 2:
                      return <IdentityStep formik={formikProps} onBack={prevStep} />;
                    default:
                      return null;
                  }
                };

                return <Form>{renderStepContent()}</Form>;
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationContainer;
